module.exports = __webpack_public_path__ + "img/p02.fbe3a59d.jpg";